// import { addFilter, applyFilters } from '@wordpress/hooks';
import appmaker from '@appmaker/core/index';
import actions from './actions';
import TemplateBuilder from './components/TemplateBuilder/index';
import ShopifyMediaLibrary from './components/AppmakerMediaLibrary/shopify';
import { uploadToServer } from './helper/upload';
import { registerBlockTypes } from './blocks'
import { getProjectData } from '@appmaker/core/store/project';
import { isAdmin as checkIsAdmin } from '@appmaker/core/store/user';
import AdditionalPermission from './components/AdditionalPermiossion'
import InitialFormModal from '@appmaker/components/templates/getting-started-forms';
import MenuImport from './components/MenuImport';

// App Bridge v4: Initialization is now handled automatically by the CDN script in index.html
// The global `window.shopify` object is created by the script tag

const ShopifyPlugin = {
	id: '@appmaker/shopify',
	name: 'Shopify',
	activate: () => {

		appmaker.registerRoute({
			routeName: '/additional-permission-required',
			component: AdditionalPermission,
		});

		const { projectData: { shopifyReauthRequired = false, meta: { URL = '' }, id } } = getProjectData();
		let doReauth = (shopifyReauthRequired && !checkIsAdmin()) || (shopifyReauthRequired && window.confirm("You need to re-authenticate with shopify for additional scopes."));
		appmaker.addFilter(
			'additional-override-component-full-screen',
			'appmaker-core',
			(content, args) => {
				if (doReauth) {
					return <AdditionalPermission />;
				} else {
					return null
				}
			}
		);
		// if (!window.location.href.match('additional-permission-required') && doReauth) {
		// 	// redirect to react route additional-permission-required
		// 	const redirectUrl = `/apps/${id}/additional-permission-required`;
		// 	if (window.shopifyApp) {
		// 		console.log("Redirecting to inside shopify", redirectUrl)
		// 		const redirect = Redirect.create(window.shopifyApp);
		// 		redirect.dispatch(
		// 			Redirect.Action.APP,
		// 			redirectUrl
		// 		);
		// 	} else {
		// 		console.log("Redirecting to ", redirectUrl)
		// 		window.location.href = redirectUrl;
		// 	}
		// }

		Object.keys(actions).map((action) =>
			appmaker.actions.registerAction(action, actions[action])
		);
		appmaker.addFilter('block-editor-header-menu', 'shopify-templates', (item) => <>{item}</>, 1)
		appmaker.addFilter('getting-started-form', 'shopify-templates', () => <InitialFormModal />)
		appmaker.addFilter('template-chooser', 'shopify-templates', () => <TemplateBuilder />)
		appmaker.addFilter('appmaker-media-library-factory', 'shopify-media', (items) => {
			// items.push(AppmakerMediaLibrary)
			items.push(ShopifyMediaLibrary)
			return items
		}, 2)
		appmaker.addFilter(
			'blockEditorMediaUpload',
			'apppmakerUpload',
			() => uploadToServer
		);
		registerBlockTypes();
		appmaker.addFilter('onboarding-path', 'woocommerce-onboarding-path', () => '/blockEditor/home?showTemplate=shopify')
		appmaker.addFilter('appdesign-next', 'woocommerce-appdesign-next-path', () => [`/blockEditor/home?showAppDownload=true`,])

		// App Bridge v4: Fullscreen feature removed (deprecated in v4)

		/**
		 * SHOPIFY menu import from website
		 */
		appmaker.addFilter('shopify-menu-import', 'shopify-template', (item, args = {}) => <MenuImport {...args} />)

	},
};

export default ShopifyPlugin;
